import { FormFeedBack, ModalBase } from '@repo/ui';
import { FormikValues } from 'formik';
import { useLocation } from 'react-router-dom';
import { Row, Col, Form, Label, Input } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  toggleModal: () => void;
  formik: FormikValues;
  resetForm: () => void;
  loading: boolean;
}

export const ModalNewCourse = ({
  isOpen,
  formik,
  resetForm,
  toggleModal,
  loading,
}: IProps) => {
  const location = useLocation();
  const courseId = location?.state?.id;

  return (
    <ModalBase.Wrapper
      size="lg"
      isOpen={isOpen}
      loading={loading}
      toggle={toggleModal}
      onClosed={resetForm}
    >
      <ModalBase.Header toggle={toggleModal} withBorderBottom>
        {courseId ? 'Editar Curso' : 'Novo Curso'}
      </ModalBase.Header>

      <Form autoComplete="off" onSubmit={formik.handleSubmit}>
        <ModalBase.Body>
          <Row>
            <Col md={12}>
              <Label htmlFor="name" className="form-label">
                Nome
              </Label>
              <Input
                id="nome"
                type="text"
                name="nome"
                className="form-control"
                value={formik.values.nome}
                onChange={formik.handleChange}
                invalid={formik.touched.nome && !!formik.errors.nome}
                autoFocus={true}
              />
              <FormFeedBack
                error={formik.errors.nome}
                isInvalid={formik.touched.nome && !!formik.errors.nome}
              />
            </Col>
          </Row>
        </ModalBase.Body>
        <ModalBase.Footer>
          <ModalBase.Actions
            loading={loading}
            goBack={toggleModal}
            actionBtnType="submit"
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
